// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__wqNx3","productName":"Table_productName__1WYZI"};